/* PDP gallery — the viewer's thumbnail rail and frame track.
 *
 * The markup works without this file: on desktop the first frame is visible
 * and the rest are hidden by CSS; on phones every frame sits in a horizontal
 * snap track the thumb can swipe. This script only wires the thumbs to the
 * frames and keeps the two in agreement.
 *
 * Two modes, one DOM, switched on the same 62em query the stylesheet uses:
 *   - desktop: a thumb click swaps the active class; frames are stacked and
 *     cross-fade. The rail also takes arrow keys.
 *   - phone:   a thumb click scrolls the track to the frame, and the TRACK is
 *     the source of truth — a swipe updates the active thumb, not the other
 *     way round, so the rail can never disagree with what is on screen.
 *
 * The section's sticky positioning is pure CSS and needs nothing here. */
(function () {
  var gallery = document.querySelector('[data-pdp-gallery]');
  if (!gallery) return;

  var track = gallery.querySelector('[data-pdp-frames]');
  var frames = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-frame]'));
  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-thumb]'));
  if (frames.length < 2 || !track) return;

  var desktop = window.matchMedia('(min-width: 62em)');
  var current = 0;

  function clamp(index) {
    return Math.max(0, Math.min(frames.length - 1, index));
  }

  function paint(index) {
    current = index;
    frames.forEach(function (frame, i) {
      frame.classList.toggle('pdp__frame--active', i === index);
    });
    thumbs.forEach(function (thumb, i) {
      var on = i === index;
      thumb.classList.toggle('pdp__thumb--active', on);
      thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function go(index, instant) {
    index = clamp(index);
    paint(index);
    if (!desktop.matches) {
      // offsetLeft is relative to the track (position: relative), so this is
      // the frame's own x inside the scroller, snap point included.
      track.scrollTo({ left: frames[index].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      go(i);
    });
  });

  /* Arrow keys walk the rail in either axis, because the rail is vertical on
     desktop and horizontal on phones and a reader should not have to know
     which. Focus follows so the next key press lands on the new thumb. */
  gallery.addEventListener('keydown', function (event) {
    if (!event.target.closest('[data-pdp-thumb]')) return;
    var delta = 0;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') delta = 1;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') delta = -1;
    if (!delta) return;
    event.preventDefault();
    go(current + delta);
    if (thumbs[current]) thumbs[current].focus();
  });

  /* Phone: read the track. Rounded to the nearest frame so the thumb flips at
     the halfway point of a swipe, which is where the snap commits. */
  var ticking = false;
  track.addEventListener(
    'scroll',
    function () {
      if (desktop.matches || ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var width = track.clientWidth || 1;
        var index = clamp(Math.round(track.scrollLeft / width));
        if (index !== current) paint(index);
      });
    },
    { passive: true }
  );

  /* Crossing the breakpoint: the stacked frames have no scroll position, so
     landing on the phone layout re-aligns the track to whatever was active. */
  function onModeChange() {
    if (!desktop.matches) go(current, true);
  }
  if (desktop.addEventListener) desktop.addEventListener('change', onModeChange);
  else if (desktop.addListener) desktop.addListener(onModeChange);

  paint(0);
})();
